import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import FileDeleteModal, { IDispatchProps, IProps } from './index';
import { ApplicationState } from '../../../../store';
import { closeModal } from '../../../../store/ui/actions';
import { deleteDoc } from '../../../../store/student/documents/actions';
import { deleteDoc as deleteFinanceDoc } from '../../../../store/student/financeDocuments/actions';
import { deleteDoc as deleteFollowUpDoc } from '../../../../store/student/followUpDocuments/actions';
import { saveMessage } from '../../../../store/student/actions';
import { getDisplayName } from '../../../../utilities/formatting';
import { IMessage } from 'api-paths-cas';

const mapStateToProps = (state: ApplicationState): IProps => {
  const { openModal } = state.ui;
  const { sponsorType, docType, sponsorKey, docKey, modalTitle, isFinanceDocumentModal, isFollowUpDocumentModal } =
    openModal || {};
  let deleteDocType = docType ? docType.split('delete-')[1] : '';
  // special case 'customRequest' has no docType only sponsorType
  if (deleteDocType === 'null') {
    deleteDocType = null;
  }

  return {
    sponsorType,
    docType: deleteDocType ?? null,
    sponsorKey: sponsorKey ?? null,
    docKey: docKey ?? null,
    modalTitle,
    userName: state.auth.student_number!,
    displayName: getDisplayName(state.auth, state.config),
    isFinanceDocumentModal: isFinanceDocumentModal ?? false,
    isFollowUpDocumentModal: isFollowUpDocumentModal ?? false,
    role: state.auth.role,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onClose: () => dispatch(closeModal()),
  onDeleteDoc: (
    message: IMessage,
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    reason: string,
    isFinDoc: boolean,
    isFollowUp: boolean,
  ) => {
    if (isFinDoc) {
      dispatch(deleteFinanceDoc(sponsorType, sponsorKey, docType, docKey, reason || ''));
    } else if (isFollowUp) {
      dispatch(deleteFollowUpDoc(sponsorType, sponsorKey, docType, docKey, reason || ''));
    } else {
      dispatch(deleteDoc(sponsorType, sponsorKey, docType, docKey, reason || ''));
    }

    dispatch(saveMessage(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FileDeleteModal);
